import React from 'react'
import ExpandablePanel from '../controls/ExpandablePanel'
import TextField from '@material-ui/core/TextField'
import { controlHasError } from '../../lib/errorHandler'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import AnimateHeight from 'react-animate-height'
import PrintText from '../../lib/PrintText'

export default function PolitykaRachunkowosciPozostale(props) {
  return (
    <ExpandablePanel title="POZOSTAŁE">
      <form autoComplete="off" className="subsection">
        <FormControlLabel
          className="pozostale"
          control={
            <Checkbox
              name="CzyPozostale"
              color="primary"
              checked={props.data.CzyPozostale}
              onChange={(e) =>
                props.onSetSectionData('CzyPozostale', e.target.checked)
              }
            />
          }
          label="Dołącz pozostałe informacje z zakresu przyjętych zasad (polityki) rachunkowości"
        />
        {!props.czyPodsumowanie ? (
          <AnimateHeight
            duration={250}
            height={props.data.CzyPozostale ? 'auto' : 0}
          >
            <TextField
              className="textarea"
              error={controlHasError(
                props.errors,
                'Pozostale',
                props.data.Pozostale,
              )}
              name="Pozostale"
              label="Opis"
              multiline
              variant="outlined"
              title={props.data.Pozostale}
              defaultValue={props.data.Pozostale}
              onBlur={(e) =>
                props.onSetSectionData('Pozostale', e.target.value)
              }
            />
          </AnimateHeight>
        ) : (
          props.data.CzyPozostale && (
            <PrintText
              text={props.data.Pozostale}
            />
          )
        )}
      </form>
    </ExpandablePanel>
  )
}
